
export const GETUSERDATAREQUEST = "GETUSERDATAREQUEST"
export const GETUSERDATASUCCESS = "GETUSERDATASUCCESS"
export const GETUSERDATAFAILURE = "GETUSERDATAFAILURE"

